import { jsx as _jsx } from "react/jsx-runtime";
import * as icons from "lucide-react";
import classNames from "../../../helpers/classNames";
const DraggableIcon = ({ item: { props, id }, elementId, ...rest }) => {
    const Icon = props?.icon?.name
        ? icons[props.icon.name]
        : icons.HelpCircleIcon;
    return (_jsx(Icon, { "editor-icon": "true", "editor-key": id, "editor-type": "Icon", ...props, className: classNames(props?.className || "min-h-3 min-w-3"), icon: null, ...rest }));
};
export default DraggableIcon;
//# sourceMappingURL=DraggableIcon.js.map